<h2 mat-dialog-title>Delete all</h2>
<mat-dialog-content>Are you sure?</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button class="fmc-button-primary" mat-button [mat-dialog-close]="true" class="fmc-button-primary">Yes</button>
</mat-dialog-actions>
